import { PreAuthenticationDto } from "../dto/pre-authentication-dto";
import { PreAuthenticationModel } from "../../models/pre-authentication-model";

export class PreAuthenticationConverter {

	static convert(dto: PreAuthenticationDto): PreAuthenticationModel {
		return new PreAuthenticationModel(
			dto.statusCode,
			dto.data.collect?.url || '',
			dto.data.collect?.key || '',
			dto.userMessageTitle,
			dto.userMessageDesc,
			dto.data.retry
		);
	}

}